import * as React from 'react'

import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import Stack from '@mui/material/Stack'

import { useTranslation } from 'components/hooks/use-translation'
import IconButton from 'components/atomic/atoms/icon-button'
import Logo from 'components/atomic/atoms/logo'

const MobileHeader = ({ onOpen }: { onOpen: () => void }) => {
    const { t } = useTranslation()

    return (
        <Stack direction="row" alignItems="center" justifyContent={'space-between'} width={'100%'}>
            <Logo />
            <IconButton
                aria-label="Burger menu"
                variant="outlined"
                tooltip={t('common:header.settings')}
                onClick={onOpen}>
                <MenuRoundedIcon fontSize="small" />
            </IconButton>
        </Stack>
    )
}

export default MobileHeader
